import styled from "@emotion/styled";
import { Image } from "antd";
import { FC, useEffect } from "react";
import { Bread } from "../../common/component/Bread";
import { ImageFill } from "../../common/component/ImageFill";
import { RightArrows } from "../../common/component/RightArrows";

const breadArr = [
	{
		title: "关于我们",
	},
	{
		title: "欧皮特介绍",
	},
];

export const Company: FC = () => {

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<Container>
			<ImageFill src={"https://optibelt.oss-cn-shanghai.aliyuncs.com/images/2022-05-28/1653669230.jpg"} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>欧皮特介绍</h1>
				</div>
				<Bread value={breadArr} />
				<div>
					<h2>专注质量</h2>
					<p>Arntz Optibelt 集团是全球领先的高性能传动皮带制造商。</p>

					<p>Optibelt 产品适用于对耐用性和质量要求较高，同时确保性能不下降的领域：机械工程、汽车、农业工程和家用电器行业。</p>

					<p>作为一家家族企业，Optibelt 在全球拥有约 2300 名员工。Arntz Optibelt 集团的总部位于赫克斯特（北莱茵-威斯特伐利亚州），在 6 个国家设立了 8 个生产基地。这些基地均践行同一管理原则：确保来自 6 个国家的 8 个生产基地的产品均具备同等品质！</p>

					<p>高品质的工艺绝非偶然：Arntz Optibelt 集团的家族经营者考虑的不只是一个季度或一年的利益，而是世世代代的利益。我们支持创新，但不会以牺牲质量为代价。Optibelt 凭借这一理念在全球市场上确立了强势品牌的地位。公司管理者和员工每天用一颗诚心、用实际行动来保持公司的品牌地位。</p>
				</div>
			</div>
			<div className='exterinor-content'>
				<div className='content'>
					<div className='imgArea'>
						<div className='title'>欧皮特世界地图</div>
						<Image src='https://optibelt.oss-cn-shanghai.aliyuncs.com/img/optibelt-unternehmen-weltweit.jpg' preview={false} />
					</div>
					<div className='siteDescription'>
						<div>
							<span>在6个国家共有8个生产基地</span>
						</div>
						<div>
							<span>在30个国家共有33个销售地点</span>
						</div>
						<div>
							<span>在20个国家设有26个物流中心</span>
						</div>
					</div>
					<a
						className='contact col-lg-3 col-md-4 col-xs-12'
						target={"_blank"}
						href='https://www.optibelt.com/en/the-company/about-optibelt/locations/international-subsidiaries/#c8099'
						rel='noreferrer'>
						查看全球联系方式
						<RightArrows />
					</a>
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.imgArea {
		position: relative;

		.title {
			position: absolute;
			left: 0;
			top: 0;
			padding: 1rem 2rem;
			color: rgb(0, 72, 133);
			z-index: 55;
			background-color: #fff;
			font-weight: bold;
			font-size: 1.5rem;
		}
	}

	.siteDescription {
		margin-top: 1rem;

		div {
			margin-bottom: 0.5rem;
			span {
				padding: 0.3rem 1rem;
				background-color: rgb(0, 72, 133);
				color: #fff;
				width: auto;
				font-size: 1.5rem;
			}
		}
	}

	.contact {
		display: flex;
		justify-content: space-between;
		border: 1px solid #ccc;
		padding: 1rem 2rem;
		font-size: 1.2rem;
		font-weight: bold;
		color: rgb(0, 72, 133);
	}
	.exterinor-content {
		background-color: #fff;

		.content {
			margin-top: 0;
			padding-top: 0;
		}
	}
`;
